// src/theme.js
import { extendTheme } from "@chakra-ui/react";
import "@fontsource/sarabun/500.css"; // Import Sarabun midium
import "@fontsource/sarabun/600.css"; // Import Sarabun semi-bold
import "@fontsource/noto-sans-thai";

const fonts = {
  heading: "'Noto Sans Thai', sans-serif",
  //body: "'Sarabun', sans-serif",
  body: "'Noto Sans Thai', sans-serif",
};
const fontWeights = {
  normal: 400,
  medium: 500,
  semibold: 600, // Use 600 for semi-bold
  bold: 700,
};

const colors = {
    primary: {
    50: "#EBF8FF",
    100: "#BEE3F8",
    200: "#90CDF4",
    300: "#63B3ED",
    400: "#4299E1",
    500: "#3182CE",
    600: "#2B6CB0",
    700: "#2C5282", // สีน้ำเงินเข้มหลักสำหรับตัวอักษร
    800: "#2A4365",
    900: "#1A365D",
  },
  header: {
    bg: "#ffffff", // พื้นหลัง Header เป็นสีขาว
    text: "#2C5282", // สีตัวอักษรหลักใน Header (primary.700)
    hoverBg: "#EBF8FF", // สีพื้นหลังเมื่อ hover ที่เมนู (primary.50)
  },
  brand: {
    50: "#e4f0ff",
    100: "#bad1ff",
    200: "#8fb2ff",
    300: "#6392ff",
    400: "#3773ff",
    500: "#004dff", // Main button color
    600: "#003dcc",
    700: "#002d99",
    800: "#001e66",
    900: "#000e33",
  },
  background: {
    //light: '#f0f4f8',  // Background color
    light: "#ffffff", // Background color
  },
  text: {
    light: "#2d3748", // Text color
  },
  menuBg: "#3a9308", // Background of menu
  menuText: "#2a7036", // Text Color of menu
  boxBg: "#fff4f0", // Background of boxes
  //headerBg: '#3a9308',  // Background of header
  headerBg: "#ffffff", // Background of header

  // Custom color
  /*custBlue: {
    500: "#5eb0f1",
    600: "#368ebc",
  },*/
  custBlue: "#368ebc",
  custOrange: "#ffbe79",
  custPurple: "#875f9c",
  custRed: "#c85454",
  custGreen: "#778da9",
  custPink: "#f078a6",
  tableHeader: "#7c97ef",

  iBlue: {
    400: "#90e0ef",
    500: "#5eb0f1",
    600: "#0077b6",
    text: "#ffffff",
  },

  iPink: {
    400: "#f7c1cc", // Hover
    500: "#f28fb1", // ปกติ
    600: "#d81b60", // Focus
    text: "#ffffff",
  },
  iRed: {
    400: "#ff9999", // Hover
    500: "#ff4d4d", // ปกติ
    600: "#cc0000", // Focus
    text: "#ffffff",
  },
  iOrange: {
    400: "#ffcc99", // Hover
    500: "#ff8c1a", // ปกติ
    600: "#e65100", // Focus
    text: "#ffffff",
  },
  iTeal: {
    400: "#80cbc4", // Hover
    500: "#4db6ac", // ปกติ
    600: "#00695c", // Focus
    text: "#ffffff",
  },
  iPurple: {
    400: "#d1c4e9", // Hover
    500: "#9575cd", // ปกติ
    600: "#5e35b1", // Focus
    text: "#ffffff",
  },
  iGreen: {
    400: "#a5d6a7", // Hover
    500: "#66bb6a", // ปกติ
    600: "#2e7d32", // Focus
    text: "#ffffff",
  },
  iBrown: {
    400: "#A27B5C", // Hover
    500: "#B17F59", // ปกติ
    600: "#D29F80", // Focus
    text: "#ffffff",
  },
  iYellow: {
    400: "#fff59d", // Hover
    500: "#ffee58", // ปกติ
    600: "#f9a825", // Focus
    text: "#333333", // ใช้สีเข้มเพราะพื้นหลังสว่าง
  },

  pageheaderScheme: {
    500: "#3a9308", // Default Background color for menu button
    text: "#ffffff", // Text color for search menu
  },

  menuScheme: {
    500: "#1c4a59", // Default Background color for menu button
    600: "#2f738a", // Hover Background color for menu button
    text: "#ffffff", // Text color for search menu
    hoverText: "#ffffff",
  },
  /*
  topmenuScheme: {
    500: '#4a9ebd', // Default Background color for menu button
    600: '#1d5466', // Hover Background color for menu button
    text: '#ffffff', // Text color for search menu
    hoverText: '#ffffff' 
  },
*/
  topmenuScheme: {
    500: "#ffffff", // Default Background color for menu button
    600: "#4a9ebd", // Hover Background color for menu button
    text: "#808080", // Text color for search menu
    hoverText: "#ffffff",
  },
  // Button color scheme
  searchScheme: {
    500: "#6482AD", // Default Background color for search button
    600: "#7FA1C3", // Hover Background color for search button
    text: "#ffffff", // Text color for search button
  },
  loginScheme: {
    500: "#5e9cde", // Default Background color for search button
    600: "#86b5e6", // Hover Background color for search button
    text: "#ffffff", // Text color for search button
  },
  confirmScheme: {
    500: "#388523", // Default Background color for ok button
    600: "#73a733", // Hover Background color for ok button
    text: "#ffffff", // Text color for search button
  },
  closeScheme: {
    500: '#C2A67A', // Default Background color for ok button
    600: '#C9997E', // Hover Background color for ok button
    text: "#ffffff", // Text color for search button
  },
  cancelScheme: {
    500: "#ED6A5E", // Default Background color for search button c51605
    600: "#ff6868", // Hover Background color for search button
    text: "#ffffff", // Text color for search button
  },
  clearScheme: {
    500: "#ff8225", // Default Background color for search button
    600: "#ffa823", // Hover Background color for search button
    text: "#ffffff", // Text color for search button
  },
  addScheme: {
    500: "#BE5985", // Default Background color for search button
    600: "#EC7FA9", // Hover Background color for search button
    text: "#ffffff", // Text color for search button
  },
  editScheme: {
    500: "#80979a", // Default Background color for search button
    600: "#a2bbba", // Hover Background color for search button
    text: "#ffffff", // Text color for search button
  },
  deleteScheme: {
    500: "#ED6A5E", // Default Background color for search button
    600: "#ff6868", // Hover Background color for search button
    text: "#ffffff", // Text color for search button
  },
  readmoreScheme: {
    500: "#6098bc", // Default Background color for search button
    600: "#95bad3", // Hover Background color for search button
    text: "#ffffff", // Text color for search button
  },
  navScheme: {
    500: "#768a96", // Default Background color for search button
    600: "#aac7d8", // Hover Background color for search button
    text: "#ffffff", // Text color for search button
  },
  backScheme: {
    500: "#848590", // Default Background color for search button
    600: "#c2c2c7", // Hover Background color for search button
    text: "#ffffff", // Text color for search button
  },
  nextScheme: {
    500: "#7d70ba", // Default Background color for search button
    600: "#9b91ca", // Hover Background color for search button
    text: "#ffffff", // Text color for search button
  },
  saveScheme: {
    500: "#5e9cde", // Default Background color for search button
    600: "#86b5e6", // Hover Background color for search button
    text: "#ffffff", // Text color for search button
  },
  downloadScheme: {
    500: "#538196", // Default Background color for search button
    600: "#9cbcc8", // Hover Background color for search button
    text: "#ffffff", // Text color for search button
  },
  uploadScheme: {
    500: "#4d6c88", // Default Background color for search button
    600: "#667e94", // Hover Background color for search button
    text: "#ffffff", // Text color for search button
  },
  submitScheme: {
    500: "#6fa8dc", // Default Background color for search button
    600: "	#9fc5e8", // Hover Background color for search button
    text: "#ffffff", // Text color for search button
  },
  viewScheme: {
    500: "#918780", // Default Background color for search button
    600: "#c8c3c0", // Hover Background color for search button
    text: "#ffffff", // Text color for search button
  },
  printScheme: {
    500: "#e38b8d", // Default Background color for search button
    600: "#ed9d9d", // Hover Background color for search button
    text: "#ffffff", // Text color for search button
  },
  sendScheme: {
    500: "#1c4e4f", // Default Background color for search button
    600: "#6a8e8f", // Hover Background color for search button
    text: "#ffffff", // Text color for search button
  },

  // end button color scheme

  iconMenuScheme: {
    500: "rgba(0, 0, 0, 0)", // Default background color for icon button
    600: "rgba(0, 0, 0, 0.3)", // Hover background color for icon button
    text: "#ffffff", // Text color for icon button
  },
  // Custom color scheme
  newScheme: {
    500: "#1888dd",
    text: "#ffffff",
  },
  updateScheme: {
    500: "#9773f4",
    text: "#ffffff",
  },
  hotScheme: {
    500: "#cc1a1a",
    text: "#ffffff",
  },
  blueScheme: {
    500: "#5eb0f1",
    text: "#ffffff",
  },
  orangeScheme: {
    500: "#ffbe79",
    text: "#ffffff",
  },
  greenScheme: {
    500: "#93c47d",
    text: "#ffffff",
  },
  purpleScheme: {
    500: "#8372fb",
    text: "#ffffff",
  },
  redScheme: {
    500: "#c85454",
    text: "#ffffff",
  },
  pinkScheme: {
    500: "#f078a6",
    text: "#ffffff",
  },
};

const customTheme = extendTheme({
  colors: colors,
  fonts,
  fontWeights, // Add fontWeights to the theme
  styles: {
    global: {
      body: {
        bg: colors.background.light,
        color: colors.text.light,
        fontWeight: "medium", // Set default font weight to medium
      },
    },
  },
  components: {
    Text: {
      baseStyle: {
        fontWeight: "medium", // Set default font weight to medium
        fontFamily: "body", // Use the 'Sarabun' font for text
      },
    },
    Button: {
      baseStyle: {
        fontWeight: "normal",
        fontFamily: "heading", // Use the 'Noto Sans Thai' font for buttons
      },
      sizes: {
        md: {
          h: "35px", // Adjust button height
          fontSize: "md",
          w: "180px", // Adjust button width
          px: "32px", // Adjust padding for width
        },
      },
      variants: {
        solid: (props) => ({
          bg: colors[props.colorScheme]?.[500] || colors.brand[500],
          color: colors[props.colorScheme]?.text || "white",
          _hover: {
            bg: colors[props.colorScheme]?.[600] || colors.brand[600],
            color: colors[props.colorScheme]?.hoverText || "white",
          },
        }),
      },
    },
    IconButton: {
      baseStyle: {
        fontWeight: "bold",
        fontFamily: "heading", // Use the 'Noto Sans Thai' font for icon buttons
      },
      variants: {
        solid: (props) => ({
          bg: colors[props.colorScheme]?.[500] || colors.iconButtonScheme[500],
          color:
            colors[props.colorScheme]?.text || colors.iconButtonScheme.text,
          _hover: {
            bg:
              colors[props.colorScheme]?.[600] || colors.iconButtonScheme[600],
            color:
              colors[props.colorScheme]?.hoverText ||
              colors.iconButtonScheme.text,
          },
        }),
      },
    },
    Box: {
      baseStyle: {
        bg: colors.boxBg,
        p: 4,
        borderRadius: "md",
      },
    },
    Heading: {
      whiteSpace: "nowrap",
    },
    Input: {
      variants: {
        custom: ({ colorScheme }) => ({
          field: {
            borderColor: `${colorScheme}.500`, // สีปกติ
            borderWidth: "2px",
            _hover: {
              borderColor: `${colorScheme}.400`, // สีเมื่อ mouseover
            },
            _focus: {
              borderColor: `${colorScheme}.600`, // สีเมื่อ focus
              boxShadow: `0 0 0 1px ${colorScheme}.600`, // เงาเมื่อ focus
            },
          },
        }),
      },
      defaultProps: {
        variant: "custom", // ทำให้ variant นี้เป็นค่าเริ่มต้น
        colorScheme: "primary", // ค่าเริ่มต้นของ colorScheme
      },
    },
    Textarea: {
      variants: {
        custom: ({ colorScheme }) => ({
          borderColor: `${colorScheme}.500`,
          borderWidth: "2px",
          _hover: {
            borderColor: `${colorScheme}.400`,
          },
          _focus: {
            borderColor: `${colorScheme}.600`,
            boxShadow: `0 0 0 1px ${colorScheme}.600`, // เงาเมื่อ focus
          },
        }),
      },
      defaultProps: {
        variant: "custom",
        colorScheme: "primary",
      },
    },
    Select: {
      variants: {
        custom: ({ colorScheme }) => ({
          field: {
            borderColor: `${colorScheme}.500`,
            borderWidth: "2px",
            _hover: {
              borderColor: `${colorScheme}.400`,
            },
            _focus: {
              borderColor: `${colorScheme}.600`,
              boxShadow: `0 0 0 1px ${colorScheme}.600`, // เงาเมื่อ focus
            },
          },
        }),
      },
      defaultProps: {
        variant: "custom",
        colorScheme: "iBlue",
      },
    },
    Radio: {
      baseStyle: ({ colorScheme }) => ({
        control: {
          borderColor: `${colorScheme}.500`,
          _checked: {
            bg: `${colorScheme}.500`,
            borderColor: `${colorScheme}.600`,
            _hover: {
              bg: `${colorScheme}.400`,
              borderColor: `${colorScheme}.400`,
            },
          },
          _hover: {
            borderColor: `${colorScheme}.400`,
          },
          _focus: {
            borderColor: `${colorScheme}.600`,
            boxShadow: `0 0 0 1px ${colorScheme}.600`, // เงาเมื่อ focus
          },
        },
      }),
      defaultProps: {
        colorScheme: "iBlue",
      },
    },
    Checkbox: {
      baseStyle: ({ colorScheme }) => ({
        control: {
          borderColor: `${colorScheme}.500`,
          _checked: {
            bg: `${colorScheme}.500`,
            borderColor: `${colorScheme}.600`,
            _hover: {
              bg: `${colorScheme}.400`,
              borderColor: `${colorScheme}.400`,
            },
          },
          _hover: {
            borderColor: `${colorScheme}.400`,
          },
          _focus: {
            borderColor: `${colorScheme}.600`,
            boxShadow: `0 0 0 1px ${colorScheme}.600`, // เงาเมื่อ focus
          },
        },
      }),
      defaultProps: {
        colorScheme: "iBlue",
      },
    },
    breakpoints: {
    base: '0px', // ขนาดเริ่มต้น (เล็กสุด)
    sm: '320px', // ขนาดเล็ก
    md: '520px', // ขนาดกลาง
    lg: '640px', // ขนาดใหญ่
    xl: '1500px', // ขนาดใหญ่พิเศษ
  },
  },
});

export default customTheme;
